import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBIcon, MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import axios from 'axios';
import ConfigData from '../Components/config';
import AppDataTable from '../Components/AppDataTable';

export default class Showcertificate extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modaldisallow: false,
            id_citifacate: null,
            statusreason: false,
            statusengreason: false,
            OLDDETAIL: null,
            OLDDETAILENG: null,
            DETAIL: null,
            DETAIL_ENG: null,
            REASONS: null,

            array_ShowReportPetition: [],
        }
        this.showpetition = this.showpetition.bind(this);
        this.edit = this.edit.bind(this);
        this.editeng = this.editeng.bind(this);
        this.Update = this.Update.bind(this);
        this.OpenRpt = this.OpenRpt.bind(this);
        this.Openfile = this.Openfile.bind(this);
        this.Openfilenotice = this.Openfilenotice.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleReasonChange = this.handleReasonChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.modaldisallow_open = this.modaldisallow_open.bind(this);
        this.modaldisallow_close = this.modaldisallow_close.bind(this);
    }

    componentDidMount() {
        if (!(localStorage.getItem('token'))) {
            window.location.href = '/rubrongkpru'
        }
        axios.get(ConfigData.SERVER_URL + 'FrontEnd_Tabian/payment/ShowBillPetitionPayment/').then((ShowReportPetition) => {
            if (ShowReportPetition.data.length !== 0) {
                var i = 0;
                while (i < ShowReportPetition.data.length) {
                    ShowReportPetition.data[i]['Index'] = i + 1;
                    if (ShowReportPetition.data[i]['STATUS'] === '1') {
                        ShowReportPetition.data[i]['Statusfill'] = <span>
                            <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                            {ShowReportPetition.data[i]['checkFile'] ? <>
                                <button className="btn btn-sm" style={{ backgroundColor: "#D48C00", color: "white" }} onClick={this.Openfilenotice} value={ShowReportPetition.data[i].ID_NO + "/" + ShowReportPetition.data[i].Filename + ".pdf"}><MDBIcon icon="eye" /> ตรวจสอบใบแจ้งความ</button>
                            </> : <></>}
                            <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                            <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                            <button className="btn btn-warning btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].DETAIL} onClick={this.edit}><MDBIcon icon="edit" /> แก้ไข</button>
                            {ShowReportPetition.data[i]['NUM_RUBRONGEN'] !== "0" ? <>
                                {ShowReportPetition.data[i]['DETAIL_ENG'] === null ? <>
                                    <button className="btn btn-sm" style={{ backgroundColor: "#D48C00", color: "white" }} value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].DETAIL + "," + ShowReportPetition.data[i].DETAIL_ENG} onClick={this.editeng}><MDBIcon icon="edit" /> แก้ไขเหตุผลอังกฤษ</button>
                                </> : <></>}
                            </> : <></>}
                            <button className="btn btn-success btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2} onClick={this.Update}><MDBIcon icon="money-bill" /> อนุญาตให้ชำระเงิน</button>
                            <button className="btn btn-danger btn-sm" value={ShowReportPetition.data[i].ID_NUMBER} onClick={this.modaldisallow_open}><MDBIcon icon="ban" /> ไม่อนุญาตให้ชำระเงิน</button></span>
                    } else if (ShowReportPetition.data[i]['STATUS'] === '2') {
                        ShowReportPetition.data[i]['Statusfill'] = <span>
                            <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                            <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                            <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                            <button className="btn btn-sm" style={{ backgroundColor: "#AAB0B3" }}><MDBIcon icon="sync" spin /> &nbsp;อยู่ระหว่างการชำระเงิน</button>
                        </span>
                    } else if (ShowReportPetition.data[i]['STATUS'] === '3') {
                        ShowReportPetition.data[i]['Statusfill'] = <span>
                            <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                            <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                            <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                            <button type="button" className="btn btn-warning btn-sm"><i className="fas fa-users"></i> รอการอนุมัติ </button>
                        </span>
                    } else if (ShowReportPetition.data[i]['STATUS'] === '4') {
                        ShowReportPetition.data[i]['Statusfill'] = <span>
                            <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                            <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + ",1"} onClick={this.Openfile} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                            <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + ",2"} onClick={this.Openfile} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                            <button type="button" className="btn btn-success btn-sm"><i class="fas fa-check-circle"></i> อนุมัติเรียบร้อย </button>
                        </span>
                    }
                    i++;
                }
                this.setState({
                    array_ShowReportPetition: {
                        columns: [
                            { label: '#', field: 'Index', },
                            { label: 'วันที่ร้องขอ', field: 'DATE_INSERT', },
                            { label: 'รหัสนักศึกษา', field: 'OLDID', },
                            { label: 'ชื่อ-นามสกุล', field: 'NAME', },
                            { label: 'ขอใบรับรองเรื่อง', field: 'TYPEPITITION_NAME', },
                            { label: 'ภาษาไทย', field: 'NUM_RUBRONGTH', },
                            { label: 'ภาษาอังกฤษ', field: 'NUM_RUBRONGEN', },
                            { label: 'สถานะ', field: 'Statusfill', },
                        ],
                        rows: ShowReportPetition.data
                    }
                })
            }
        })
    }

    showpetition(event) {
        var splitvalue = event.target.value.split(",")
        window.open(
            'https://mua.kpru.ac.th/apipostpone/postponepdf/reportpetition_print.php?idrpt=' + splitvalue[0] + '&ID_NO=' + splitvalue[1],
            '_blank'
        );
    }

    edit(event) {
        // event.preventDefault();
        var splitvalue = event.target.value.split(",")
        this.setState({ id_citifacate: splitvalue[0] });
        this.setState({ OLDDETAIL: splitvalue[1] });
        this.setState({ DETAIL: splitvalue[1] });
        this.setState({ statusreason: true });
    }

    editeng(event) {
        // event.preventDefault();
        var splitvalue = event.target.value.split(",")
        this.setState({ id_citifacate: splitvalue[0] });
        this.setState({ DETAIL: splitvalue[1] });
        if (splitvalue[2] === "null") {
            this.setState({ DETAIL_ENG: null });
        } else {
            this.setState({ DETAIL_ENG: splitvalue[2] });
            this.setState({ OLDDETAILENG: splitvalue[2] });
        }
        this.setState({ statusengreason: true });
    }

    toggle(event) {
        this.setState({ statusreason: false });
        this.setState({ statusengreason: false });
        this.setState({ id_citifacate: null });
        this.setState({ DETAIL: null });
        this.setState({ DETAIL_ENG: null });
        this.setState({ OLDDETAIL: null });
        this.setState({ OLDDETAILENG: null });
    }

    modaldisallow_open(event) {
        event.preventDefault();
        this.setState({ modaldisallow: true });
        this.setState({ id_citifacate: event.target.value });
    }

    modaldisallow_close(event) {
        event.preventDefault();
        this.setState({ modaldisallow: false });
        this.setState({ REASONS: null });
        this.setState({ id_citifacate: null });
    }

    Update(event) {
        var splitvalue = event.target.value.split(",")
        let bodydata = {
            REASONS: this.state.REASONS,
        }
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Accept': 'application/json;odata=verbose'
        }
        axios.post(ConfigData.SERVER_URL + 'FrontEnd_Tabian/payment/updatestatust/' + splitvalue[0] + '/' + splitvalue[1] + "/" + localStorage.getItem('id'), bodydata, { headers }).then((respone) => {
            axios.get(ConfigData.SERVER_URL + 'FrontEnd_Tabian/payment/ShowBillPetitionPayment/').then((ShowReportPetition) => {
                if (ShowReportPetition.data.length !== 0) {
                    var i = 0;
                    while (i < ShowReportPetition.data.length) {
                        ShowReportPetition.data[i]['Index'] = i + 1;
                        if (ShowReportPetition.data[i]['STATUS'] === '1') {
                            ShowReportPetition.data[i]['Statusfill'] = <span>
                                <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                                {ShowReportPetition.data[i]['checkFile'] ? <>
                                    <button className="btn btn-sm" style={{ backgroundColor: "#D48C00", color: "white" }} onClick={this.Openfilenotice} value={ShowReportPetition.data[i].ID_NO + "/" + ShowReportPetition.data[i].Filename + ".pdf"}><MDBIcon icon="eye" /> ตรวจสอบใบแจ้งความ</button>
                                </> : <></>}
                                <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                                <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                                <button className="btn btn-warning btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].DETAIL} onClick={this.edit}><MDBIcon icon="edit" /> แก้ไข</button>
                                {ShowReportPetition.data[i]['NUM_RUBRONGEN'] !== "0" ? <>
                                    {ShowReportPetition.data[i]['DETAIL_ENG'] === null ? <>
                                        <button className="btn btn-sm" style={{ backgroundColor: "#D48C00", color: "white" }} value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].DETAIL + "," + ShowReportPetition.data[i].DETAIL_ENG} onClick={this.editeng}><MDBIcon icon="edit" /> แก้ไขเหตุผลอังกฤษ</button>
                                    </> : <></>}
                                </> : <></>}
                                <button className="btn btn-success btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2} onClick={this.Update}><MDBIcon icon="money-bill" /> อนุญาตให้ชำระเงิน</button>
                                <button className="btn btn-danger btn-sm" value={ShowReportPetition.data[i].ID_NUMBER} onClick={this.modaldisallow_open}><MDBIcon icon="ban" /> ไม่อนุญาตให้ชำระเงิน</button></span>
                        } else if (ShowReportPetition.data[i]['STATUS'] === '2') {
                            ShowReportPetition.data[i]['Statusfill'] = <span>
                                <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                                <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                                <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                                <button className="btn btn-sm" style={{ backgroundColor: "#AAB0B3" }}><MDBIcon icon="sync" spin /> &nbsp;อยู่ระหว่างการชำระเงิน</button>
                            </span>
                        } else if (ShowReportPetition.data[i]['STATUS'] === '3') {
                            ShowReportPetition.data[i]['Statusfill'] = <span>
                                <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                                <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                                <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                                <button type="button" className="btn btn-warning btn-sm"><i className="fas fa-users"></i> รอการอนุมัติ </button>
                            </span>
                        } else if (ShowReportPetition.data[i]['STATUS'] === '4') {
                            ShowReportPetition.data[i]['Statusfill'] = <span>
                                <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                                <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + ",1"} onClick={this.Openfile} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                                <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + ",2"} onClick={this.Openfile} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                                <button type="button" className="btn btn-success btn-sm"><i class="fas fa-check-circle"></i> อนุมัติเรียบร้อย </button>
                            </span>
                        }
                        i++;
                    }

                    this.setState({
                        array_ShowReportPetition: {
                            columns: [
                                { label: '#', field: 'Index', },
                                { label: 'วันที่ร้องขอ', field: 'DATE_INSERT', },
                                { label: 'รหัสนักศึกษา', field: 'OLDID', },
                                { label: 'ชื่อ-นามสกุล', field: 'NAME', },
                                { label: 'ขอใบรับรองเรื่อง', field: 'TYPEPITITION_NAME', },
                                { label: 'ภาษาไทย', field: 'NUM_RUBRONGTH', },
                                { label: 'ภาษาอังกฤษ', field: 'NUM_RUBRONGEN', },
                                { label: 'สถานะ', field: 'Statusfill', },
                            ],
                            rows: ShowReportPetition.data
                        }
                    })
                }
                this.setState({ modaldisallow: false });
                this.setState({ REASONS: null });
                this.setState({ id_citifacate: null });
            })
        });
    }

    Openfile(event) {
        var splitvalue = event.target.value.split(",");
        if (splitvalue[1] === "1") {
            window.open(
                "https://e-certificate.kpru.ac.th/downloads_file/" + splitvalue[0] + "-thai.pdf", "_blank"
            );
        } else {
            window.open(
                "https://e-certificate.kpru.ac.th/downloads_file/" + splitvalue[0] + "-en.pdf", "_blank"
            );
        }
    }

    OpenRpt(event) {
        var splitvalue = event.target.value.split(",");
        if (splitvalue[1] === "1") {
            if (splitvalue[3] === "32" || splitvalue[3] === "33") {
                window.open(
                    "http://e-certificate.kpru.ac.th/RubrongKru.aspx?Id_number=" + splitvalue[0], "_blank"
                );
            } else if (splitvalue[3] === "30") {
                window.open(
                    "http://e-certificate.kpru.ac.th/RubrongCourse.aspx?Id_number=" + splitvalue[0], "_blank"
                );
            } else {
                window.open(
                    "http://e-certificate.kpru.ac.th/ThaiCertificate.aspx?Id_number=" + splitvalue[0], "_blank"
                );
            }
        } else if (splitvalue[1] === "2") {
            window.open(
                "http://e-certificate.kpru.ac.th/EngCertificate.aspx?Id_number=" + splitvalue[0], "_blank"
            );
            // console.log("http://e-certificate.kpru.ac.th/EngCertificate.aspx?Id_number=" + splitvalue[0], "_blank")
        }
    }

    Openfilenotice(event) {
        window.open(
            "https://mua.kpru.ac.th/FrontEnd_Tabian/public/uploads/Documentnotice/" + event.target.value, "_blank"
        );
    }

    handleReasonChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleSubmit(event) {
        event.preventDefault();
        let bodydata = {};
        if (this.state.DETAIL_ENG === null) {
            bodydata = {
                DETAIL: this.state.DETAIL,
                OLDDETAIL: this.state.OLDDETAIL,
            }
        } else {
            bodydata = {
                DETAIL: this.state.DETAIL,
                DETAIL_ENG: this.state.DETAIL_ENG,
                OLDDETAIL_ENG: this.state.OLDDETAILENG,
            }
        }
        axios.post(ConfigData.SERVER_URL + 'FrontEnd_Tabian/payment/UpdatePetition/' + this.state.id_citifacate, bodydata).then((data) => {
            if (data.data === 1) {
                this.setState({ statusreason: false });
                this.setState({ statusengreason: false });
                this.setState({ id_citifacate: null });
                this.setState({ DETAIL: null });
                this.setState({ DETAIL_ENG: null });
                this.setState({ OLDDETAIL: null });
                this.setState({ OLDDETAIL_ENG: null });
                window.location.reload()
            }
        })
    }

    render() {
        return (<>
            <span className="white-text mt-3" style={{ fontSize: '22px' }}>สถานะการขอใบรับรอง</span><span className="white-text mt-3" style={{ fontSize: '16px' }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>

            <MDBRow>
                <MDBCol lg="12" md="12" sm="12">
                    <MDBCard className="mt-3">
                        <MDBCardBody>
                            <MDBCardTitle className="h5">
                                สถานะการขอใบรับรอง
                            </MDBCardTitle>
                            <MDBCardText>
                                <AppDataTable data={this.state.array_ShowReportPetition} />
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBModal isOpen={this.state.modaldisallow} toggle={this.modaldisallow_close} centered>
                <MDBModalHeader toggle={this.modaldisallow_close}>รายละเอียดที่ไม่อนุญาตให้ชำระเงิน</MDBModalHeader>
                <MDBModalBody>
                    <div className="form-outline mt-2">
                        <label className="form-label" for="REASONS">รายละเอียดที่ไม่อนุญาตให้ชำระเงิน</label>
                        <input type="text" className="form-control" id="REASONS" name="REASONS" placeholder="รายละเอียดที่ไม่อนุญาตให้ชำระเงิน" value={this.state.REASONS} onChange={this.handleReasonChange} required />
                    </div>
                </MDBModalBody>
                <MDBModalFooter>
                    <button type="button" className="btn btn-primary btn-md" onClick={this.Update} value={this.state.id_citifacate + "," + 0}>บันทึกข้อมูล</button>
                    <button type="button" className="btn btn-danger btn-md" onClick={this.modaldisallow_close}>ยกเลิก</button>
                </MDBModalFooter>
            </MDBModal>

            <MDBModal isOpen={this.state.statusreason} toggle={this.toggle} centered>
                <MDBModalHeader toggle={this.toggle}>แก้ไข</MDBModalHeader>
                <form onSubmit={this.handleSubmit}>
                    <MDBModalBody>
                        <div className="form-outline mt-2">
                            <label className="form-label" for="DETAIL">รายละเอียดคำร้องและเหตุผลประกอบ</label>
                            <input type="text" className="form-control" id="DETAIL" name="DETAIL" placeholder="รายละเอียดคำร้องและเหตุผลประกอบ" value={this.state.DETAIL} onChange={this.handleReasonChange} required />
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <button type="submit" className="btn btn-primary btn-md">บันทึกข้อมูล</button>
                        <button type="button" className="btn btn-danger btn-md" onClick={this.toggle}>ยกเลิก</button>
                    </MDBModalFooter>
                </form>
            </MDBModal>

            <MDBModal isOpen={this.state.statusengreason} toggle={this.toggle} centered>
                <MDBModalHeader toggle={this.toggle}>เพิ่มเหตุผลอังกฤษ</MDBModalHeader>
                <form onSubmit={this.handleSubmit}>
                    <MDBModalBody>
                        <div className="form-outline mt-2">
                            <label className="form-label">ขอเอกสารทางการศึกษาเพื่อ <span className="text-primary">{this.state.DETAIL}</span></label>
                        </div>
                        <div className="form-outline">
                            <label className="form-label" for="DETAIL_ENG">รายละเอียดคำร้องและเหตุผลประกอบภาษาอังกฤษ</label>
                            <input type="text" className="form-control" id="DETAIL_ENG" name="DETAIL_ENG" placeholder="รายละเอียดคำร้องและเหตุผลประกอบภาษาอังกฤษ" value={this.state.DETAIL_ENG} onChange={this.handleReasonChange} required />
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <button type="submit" className="btn btn-primary btn-md">บันทึกข้อมูล</button>
                        <button type="button" className="btn btn-danger btn-md" onClick={this.toggle}>ยกเลิก</button>
                    </MDBModalFooter>
                </form>
            </MDBModal>
        </>)
    }
}
